/** Export only the selected square, never the uncropped source image. */
export default async function cropSquareImage(source, crop) {
  if (!crop || crop.width <= 0 || crop.height <= 0)
    throw new Error("Seleziona un ritaglio valido.");
  const image = await new Promise((resolve, reject) => {
    const element = new Image();
    element.onload = () => resolve(element);
    element.onerror = () => reject(new Error("Impossibile leggere l’immagine selezionata."));
    element.src = source;
  });
  const canvas = document.createElement("canvas");
  canvas.width = 512;
  canvas.height = 512;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Impossibile ritagliare l’immagine.");
  // Crop coordinates from react-easy-crop are expressed in source-image pixels.
  context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, 512, 512);
  return new Promise((resolve, reject) =>
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Impossibile creare la foto ritagliata."));
    }, "image/png"),
  );
}
